import React from 'react'
import { AuthenticatedTemplate } from '@azure/msal-react'
import { Avatar } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { useSelector } from 'react-redux'
import { selectHeaderAvatarSrc, selectUser } from '../../../../store/auth/selectors'
import { useAppHeaderRightMenuStyles } from '../app-header-right-menu.styles'
import { useMenuForAuthenticated } from './menu-for-authenticated.hook'
import { MyAccountMenu } from './my-account-menu'

export const MenuForAuthenticated: React.FC = (): React.ReactElement => {
  const classes = useAppHeaderRightMenuStyles()
  const { anchorEl, setAnchorEl, myAccountClickHandler } = useMenuForAuthenticated()
  const user = useSelector(selectUser)
  const avatarSrc = useSelector(selectHeaderAvatarSrc)

  return (
    <AuthenticatedTemplate>
      <div className={classes.hideForMobile}>
        <span onClick={myAccountClickHandler} className={classes.link}>
          <Avatar
            className={classes.userAvatar}
            src={`${avatarSrc}?${Date.now()}`}
          />
          <span className={classes.accountName}>{user.name}</span>
          <ExpandMoreIcon />
        </span>
      </div>
      <MyAccountMenu anchorEl={anchorEl} setAnchorEl={setAnchorEl} />
    </AuthenticatedTemplate>
  )
}
